<script>
import ChannelMultiselect from './ChannelMultiselect.vue';
import ChannelsIndicator from './ChannelsIndicator/ChannelsIndicator';
import FormWrapper from "@/components/ui/forms/FormWrapper";
import FormControl from "@/components/ui/forms/FormControl";
import FormLabel from "@/components/ui/forms/FormLabel";
import {useDvFlagAccess} from "../../../services/featureFlag";

export default {
  name: "ChannelSelectGroup",
  methods: {useDvFlagAccess},
  components: {
    ChannelMultiselect,
    ChannelsIndicator,
    FormWrapper,
    FormControl,
    FormLabel,
  },
  props: {
    value: {
      type: Object,
    }
  },
  data: function () {
    return {
      channels: this.value
    };
  },
  watch: {
    value: function (newVal) {
      this.channels = newVal;
    },
    channels: function (newVal) {
      this.$emit("input", newVal);
    }
  }
}
</script>

<template>
  <FormWrapper v-if="value">
    <ChannelsIndicator :channels="channels" />
    <FormControl>
      <FormLabel>
        <i class="fa fa-lg text-muted fa-commenting mr-2" aria-hidden="true"></i>
          {{ $t('profile.form.sms') }}
      </FormLabel>
      <ChannelMultiselect
        v-model="channels.sms"
        channelType="mobile"
      />
    </FormControl>
    <FormControl>
      <FormLabel>
        <i class="fa fa-lg text-muted fa-volume-control-phone mr-2" aria-hidden="true"></i>
        {{ $t('profile.form.text_to_speech') }}
      </FormLabel>
      <div
        class="alert alert-warning"
        v-if="!useDvFlagAccess('beepiz-shift-can:read')"
        v-text="$t('profile.form.channels_pro_licences_warning')"
      ></div>
      <ChannelMultiselect
        v-model="channels.tts"
        channelType="phone,mobile"
        :disabled="!useDvFlagAccess('beepiz-tts-can:read')"
      />
    </FormControl>
    <FormControl>
      <FormLabel>
        <i class="fa fa-lg text-muted fa-envelope mr-2" aria-hidden="true"></i>
        {{ $t('profile.form.email') }}
      </FormLabel>
      <ChannelMultiselect
        v-model="channels.email"
        channelType="email"
      />
    </FormControl>
  </FormWrapper>
</template>

<style>
</style>